import "../../../../assets/presentation/components/controls/text-input/text-input-y_ULd0vA.css";
import { TextInputType } from "./text-input-type.js";
/* empty css           */
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/text-input/text-input.tsx
var TextInput = forwardRef(({ placeHolder, value, name, maxLength, inputType, inputMode, className, autoComplete, style, min, max, checked, id, isDisabled, onFocus, onChange, onBlur, onKeyDown, enterKeyHint = "enter" }, ref) => {
	const isDate = inputType === TextInputType.DATE;
	return /* @__PURE__ */ jsx("input", {
		ref,
		style,
		name,
		id,
		autoComplete,
		maxLength,
		type: inputType,
		placeholder: placeHolder,
		value,
		inputMode: isDate ? void 0 : inputMode,
		disabled: isDisabled,
		onFocus,
		onChange,
		onBlur,
		onKeyDown,
		checked,
		min,
		max,
		enterKeyHint,
		className: classNames("text-input", className, {
			empty: !value,
			password: inputType === TextInputType.PASSWORD,
			date: isDate
		})
	});
});
//#endregion
export { TextInput };

//# sourceMappingURL=text-input2.js.map